import s from './Label.module.css';

export default function Label({ as: Tag = 'span', children, className = '', ...rest }) {
  return (
    <Tag className={`${s.label} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}
